(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  class BlogCategoryTabs extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleTabClick);
    }

    handleTabClick(event) {
      const tab = event.target.closest('[data-category-tab]');
      if (!tab) return;

      const category = tab.dataset.category;

      this.querySelectorAll('[data-category-tab]').forEach((el) => {
        const isActive = el === tab;
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      const label = this.querySelector('[data-active-category-label]');
      if (label) label.textContent = tab.textContent.trim();

      const postsContainer = this.closest('blog-posts-list');
      if (!postsContainer) return;

      postsContainer.querySelectorAll('.blog-post-item').forEach((item) => {
        const itemCategories = item.dataset.category
          ? item.dataset.category.split(',')
          : [];
        item.hidden = category !== '' && !itemCategories.includes(category);
      });
    }
  }

  if (!customElements.get('category-tabs')) {
    customElements.define('category-tabs', BlogCategoryTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
